export const contactsData = {
    email: 'grosservonsirius@gmail.com',
    phone: '+54 3734 484075',
    address: 'Machagai, Chaco, Argentina - 3534 ',

    sheetAPI: ''
}